<script>
import api from "@/helpers/api-rest/api.js";

/**
 * Dashboard stat widgets (counts + quick navigation).
 */
export default {
  data() {
    return {
      statData: [],
      isLoading: false,
      loadError: null,
    };
  },
  mounted() {
    this.loadStats();
  },
  methods: {
    formatValue(value) {
      const n = Number(value);
      if (Number.isNaN(n)) {
        return value;
      }
      return n.toLocaleString();
    },
    async loadStats() {
      this.isLoading = true;
      this.loadError = null;
      try {
        const response = await api.get({
          url: "/api/v1/dashboard/stats",
          withLoading: false,
        });
        const stats = response?.data?.data?.stats;
        this.statData = Array.isArray(stats) ? stats : [];
      } catch (error) {
        console.error("Error loading dashboard stats:", error);
        this.loadError = error;
        this.statData = [];
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<template>
  <div class="row">
    <div v-if="isLoading" class="col-12 text-center py-4">
      <span class="text-muted">Cargando estadísticas…</span>
    </div>
    <div
      v-else-if="loadError"
      class="col-12"
    >
      <div class="alert alert-warning mb-0" role="alert">
        No se pudieron cargar las estadísticas del panel.
      </div>
    </div>
    <template v-else>
      <div
        class="col-md-4"
        v-for="(data, index) in statData"
        :key="index"
      >
        <div class="card">
          <div class="card-body">
            <div class="media">
              <div class="media-body overflow-hidden">
                <p class="text-truncate font-size-14 mb-2">{{ data.title }}</p>
                <h4 class="mb-0">{{ formatValue(data.value) }}</h4>
              </div>
              <div class="text-primary">
                <i :class="`${data.icon} font-size-24`"></i>
              </div>
            </div>
          </div>

          <div class="card-body border-top py-3">
            <div class="text-truncate">
              <router-link
                v-if="data.route_name"
                :to="{ name: data.route_name }"
                class="badge badge-soft-primary font-size-11"
              >
                <i class="ri-arrow-right-line align-middle"></i>
                {{ data.action_label }}
              </router-link>
              <span v-else class="text-muted font-size-12">{{ data.action_label }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
  <!-- end row -->
</template>
